import { getVehicleInitialInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleInformation/getVehicleInformation.type';
import { getVehicleInitialInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleInitialInformation/getVehicleInitialInformationFunction';
import { queryOptions } from '@tanstack/react-query';

export const getVehicleInitialInformationOption = ({
  id,
}: getVehicleInitialInformationType) =>
  queryOptions({
    queryKey: ['patch-part_one-vehicle-information', id],
    queryFn: () => getVehicleInitialInformationFunction({ id }),
  });
